// FruitBushes theme JS
document.addEventListener('DOMContentLoaded', function() {
  // Duplicate marquee content for seamless scroll
  document.querySelectorAll('.marquee-track').forEach(function(track) {
    if (!track.dataset.duplicated) {
      track.innerHTML = track.innerHTML + track.innerHTML;
      track.dataset.duplicated = 'true';
    }
  });
});
